import { render, staticRenderFns } from "./batchApplicationSubmit.vue?vue&type=template&id=0744361e&scoped=true"
import script from "./batchApplicationSubmit.vue?vue&type=script&lang=js"
export * from "./batchApplicationSubmit.vue?vue&type=script&lang=js"
import style0 from "./batchApplicationSubmit.vue?vue&type=style&index=0&id=0744361e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0744361e",
  null
  
)

export default component.exports